import { SaveResultMessage } from "@/components/test/SaveResultMessage";
import { Button } from "@/components/ui/button";
import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableFooter,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table"
import { ChartBar, Table as TableIcon } from "lucide-react";
import { useState } from "react";

export const YoungResults = ({ scores }) => {
    const [view, setView] = useState("table");

    const calculate = (...args) => {
        const sum = args.reduce((acc, cur) => acc + (scores[cur - 1] || 0), 0);
        const sum56 = args.filter(i => scores[i] === 5 || scores[i] === 6).length;

        return {
            sum,
            avg: parseFloat((sum / args.length).toFixed(2)),
            sumPercent: parseFloat((((sum - 5) / 25) * 100).toFixed(2)),
            sum56
        }
    }

    const summarize = () => {
        const schemeOne = new Map([
            ["Эмоциональная депривированность", calculate(1, 19, 37, 55, 73)],
            ["Покинутость/Нестабильность", calculate(2, 20, 38, 56, 74)],
            ["Недоверие/Ожидание жестокого обращения", calculate(3, 21, 39, 57, 75)],
            ["Социальная отчужденность", calculate(4, 22, 40, 58, 76)],
            ["Дефективность/Стыд", calculate(5, 23, 41, 59, 77)],
        ])

        const schemeTwo = new Map([
            ["Неуспешность", calculate(6, 24, 42, 60, 78)],
            ["Зависимость/Беспомощность", calculate(7, 25, 43, 61, 79)],
            ["Уязвимость", calculate(8, 26, 44, 62, 80)],
            ["Спутанность/Неразвитая идентичность", calculate(9, 27, 45, 63, 81)],
        ])

        const schemeThree = new Map([
            ["Привилегированность/Грандиозность", calculate(14, 32, 50, 68, 86)],
            ["Недостаточность самоконтроля", calculate(15, 33, 51, 69, 87)],
        ])

        const schemeFour = new Map([
            ["Покорность", calculate(10, 28, 46, 64, 82)],
            ["Самопожертвование", calculate(11, 29, 47, 65, 83)],
            ["Поиск одобрения", calculate(16, 34, 52, 70, 88)],
        ])

        const schemeFive = new Map([
            ["Подавление эмоций", calculate(12, 30, 48, 66, 84)],
            ["Жесткие стандарты/ Придирчивость", calculate(13, 31, 49, 67, 85)],
            ["Негативизм/Пессимизм", calculate(17, 35, 53, 71, 89)],
            ["Пунитивность", calculate(18, 36, 54, 72, 90)],
        ])

        return [
            ...Array.from(schemeOne, ([name, val]) => ({ type: "Нарушение связи и отвержение", name, ...val })),
            ...Array.from(schemeTwo, ([name, val]) => ({ type: "Нарушение автономии", name, ...val })),
            ...Array.from(schemeThree, ([name, val]) => ({ type: "Нарушенные границы", name, ...val })),
            ...Array.from(schemeFour, ([name, val]) => ({ type: "Направленность на других", name, ...val })),
            ...Array.from(schemeFive, ([name, val]) => ({ type: "Сверхбдительность и запреты", name, ...val })),
        ]
    }

    const data = summarize()


    const toggleView = () => setView(view === "bar" ? "table" : "bar")

    return (
        <div className="mt-6">
            <SaveResultMessage />
            <div className="flex items-center justify-end">
                <Button variant="outline" onClick={toggleView}>
                    {view === "table" ? (
                        <ChartBar className="w-4 h-4" />
                    ) : (
                        <TableIcon className="w-4 h-4" />
                    )}
                </Button>
            </div>

            {view === "table" ? (
                <Table>
                    <TableCaption>Результаты Схем YSQ-S3R</TableCaption>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Тип</TableHead>
                            <TableHead>Схема</TableHead>
                            <TableHead className="text-right">Сумма</TableHead>
                            <TableHead className="text-right">Среднее</TableHead>
                            <TableHead className="text-right">%</TableHead>
                            <TableHead className="text-right">Сумма акцентуации</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {data.map((item, i) => (
                            <TableRow key={i}>
                                <TableCell>{i > 0 && data[i - 1].type === item.type ? null : item.type}</TableCell>
                                <TableCell>{item.name}</TableCell>
                                <TableCell className="text-right">{item.sum}</TableCell>
                                <TableCell className="text-right">{item.avg}</TableCell>
                                <TableCell className="text-right">{item.sumPercent}%</TableCell>
                                <TableCell className="text-right">{item.sum56}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={2}>
                                <div className="text-right">
                                    <span>Сумма всех схем:</span>
                                </div>
                            </TableCell>
                            <TableCell className="text-right">
                                <div className="text-right">
                                    <span>{data.reduce((acc, cur) => acc + cur.sum, 0)}</span>
                                </div>
                            </TableCell>
                            <TableCell colSpan={3} />
                        </TableRow>
                    </TableFooter>
                </Table>
            ) : (
                <Table>
                    <TableCaption>Графические результаты</TableCaption>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Схема</TableHead>
                            <TableHead className="text-right border-l">10%</TableHead>
                            <TableHead className="text-right border-l">20%</TableHead>
                            <TableHead className="text-right border-l">30%</TableHead>
                            <TableHead className="text-right border-l">40%</TableHead>
                            <TableHead className="text-right border-l">50%</TableHead>
                            <TableHead className="text-right border-l">60%</TableHead>
                            <TableHead className="text-right border-l">70%</TableHead>
                            <TableHead className="text-right border-l">80%</TableHead>
                            <TableHead className="text-right border-l">90%</TableHead>
                            <TableHead className="text-right border-l">100%</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {data.map((item, i) => (
                            <TableRow key={i}>
                                <TableCell>{item.name}</TableCell>
                                {Array.from({ length: Math.round(item.sumPercent / 10) }, (_, i) => (
                                    <TableCell key={i} colSpan={1} className="bg-green-100 border-l"></TableCell>
                                ))}
                                {Array.from({ length: 10 - Math.round(item.sumPercent / 10) }, (_, i) => (
                                    <TableCell key={i} colSpan={1} className="border-l"></TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}


        </div >
    )
}
